<template>
  <div>
    <v-tabs v-model="tab">
      <v-tab href="#tab-1">清單</v-tab>
      <v-tab href="#tab-2">申請單</v-tab>
      <v-tab-item value="tab-1">
        <v-card flat>
          <install-position-data-table :tab="tab" />
        </v-card>
      </v-tab-item>
      <v-tab-item value="tab-2">
        <v-card flat>
          <install-position-apply-data-table :tab="tab" />
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import InstallPositionDataTable from '@/components/Installposition/InstallPositionDataTable.vue'
import InstallPositionApplyDataTable from '@/components/Installposition/InstallPositionApplyDataTable.vue'
export default {
  name: 'InstallPosition',
  components: {
    InstallPositionDataTable,
    InstallPositionApplyDataTable
  },
  data: () => ({
    tab: 'tab-1'
  }),
  mounted () {},
  watch: {},
  computed: {},
  methods: {}
}
</script>
